import React from "react";
import {Card, ListGroup} from "react-bootstrap";
import RulesEditDistanceGSEntry from "./RulesEditDistanceGSEntry";

class RulesEditDistanceGS extends React.Component {
    constructor(props) {
        super(props);
        this.editRuleEntry = this.editRuleEntry.bind(this);
        this.recalculateTotal = this.recalculateTotal.bind(this);
        this.calculatePassFailStats = this.calculatePassFailStats.bind(this);
    }

    calculatePassFailStats(rule) {
        const histogramData = this.props.getHistogramData?.(rule.organ, rule.organ);
        if (!histogramData?.data?.[rule.percentage]) {
            return { pass: 0, total: 0 };
        }

        const dataAtPercentile = histogramData.data[rule.percentage];
        let passing = 0, total = 0;

        // Calculate total required points for passing (55% of total possible)
        const requiredPoints = this.props.data.reduce((sum, rule) => {
            if (!rule.delete && rule.ruleType === "struct2GSrules") {
                return sum + (rule.percentage * rule.grading / 100);
            }
            return sum;
        }, 0);

        const achievedPoints = (rule.percentage * rule.grading / 100);
        const isPassingThreshold = achievedPoints >= (requiredPoints * 0.55);

        for (let i = 1; i < dataAtPercentile.length; i++) {
            const value = dataAtPercentile[i];
            if (value !== null && !isNaN(value)) {
                total++;
                if (value <= rule.threshold && isPassingThreshold) {
                    passing++;
                }
            }
        }

        return { pass: passing, total };
    }
    getTotalStats() {
        let totalPassing = 0, totalStudents = 0;

        this.props.data.forEach(rule => {
            if (!rule.delete && rule.ruleType === "struct2GSrules") {
                const stats = this.calculatePassFailStats(rule);
                totalPassing += stats.pass;
                totalStudents += stats.total;
            }
        });

        return totalStudents > 0 ?
            `${totalPassing} / ${totalStudents} (${((totalPassing / totalStudents) * 100).toFixed(1)}%) passing` :
            'No data available';
    }

    editRuleEntry(index, nval) {
        if (nval === null) {
            if (window.confirm("Are you sure you want to remove this rule?")) {
                this.props.data[index].delete = true;
                this.recalculateTotal(index);
                this.props.cb(this.props.data);
                this.forceUpdate();
            }
            return;
        }

        // Scale the grading value based on maxGrading
        const maxGrading = this.props.maxGrading || 100;
        const scaleFactor = maxGrading / 100;
        nval.grading = nval.grading * scaleFactor;

        this.props.data[index] = nval;
        this.recalculateTotal(index);
        this.props.data[index].modified = true;
        this.props.cb(this.props.data);
        this.forceUpdate();
    }

    recalculateTotal(index) {
        let total = 0;
        let options = 0;
        const maxGrading = this.props.maxGrading || 100;

        for (let i = 0; i < this.props.data.length; i++) {
            if(this.props.data[i].delete || this.props.data[i].ruleType !== "struct2GSrules")
                continue;
            total += this.props.data[i].grading;
            options++;
        }
        if(options === 0)
            return;

        let point_to_adjust_per_rule = (maxGrading - total);
        let abs_ptapr = Math.abs(point_to_adjust_per_rule);
        let doAbove = false;
        let max_iter = 0;

        while (abs_ptapr > 0) {
            max_iter++;
            if(max_iter > 100)
                break;
            let abs_ptapr_c = abs_ptapr;
            for (let i = 0; i < this.props.data.length; i++) {
                if(this.props.data[i].delete || this.props.data[i].ruleType !== "struct2GSrules")
                    continue;
                if ((index === -1 || i > index || (i !== index && doAbove)) && abs_ptapr > 0) {
                    let newval = Math.min(Math.max(this.props.data[i].grading + Math.sign(point_to_adjust_per_rule), 0), maxGrading);
                    let diff = Math.abs(this.props.data[i].grading - newval);
                    this.props.data[i].grading = newval;
                    this.props.data[i].modified = true;
                    abs_ptapr -= diff;
                }
            }
            if(abs_ptapr_c === abs_ptapr) {
                doAbove = true;
            }
        }
    }

    calculateTotal() {
        return this.props.data.reduce((total, obj) =>
            obj.delete || obj.ruleType !== "struct2GSrules" ? total : total + obj.grading, 0);
    }

    render() {
        return (
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <span>Distance to golden standard</span>
                    <span className="text-muted small">{this.getTotalStats()}</span>
                </Card.Header>
                <ListGroup variant="flush">
                    {this.props.data.map((val, i) =>
                        val.delete === undefined && val.ruleType === "struct2GSrules" ?
                            <RulesEditDistanceGSEntry
                                key={i}
                                data={val}
                                total={this.calculateTotal()}
                                maxGrading={this.props.maxGrading}
                                cb={(nval) => this.editRuleEntry(i, nval)}
                            /> : ''
                    )}
                </ListGroup>
            </Card>
        );
    }
}

export default RulesEditDistanceGS;